export enum ESpecOfferActionTypes {
    setIsLoading = '@spec_offers/setIsLoading',
    setOffers = '@spec_offers/setOffers',
    setSelectedOfferId = '@spec_offers/setSelectedOfferId',
    setPopupState = '@spec_offers/setPopupState',
    setIsPopupOpened = '@spec_offers/setIsPopupOpened',
    setOfferTransaction = '@spec_offers/setOfferTransaction',
    setErrorMessage = '@spec_offers/setErrorMessage',
}
